import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AttachmentsService} from "../../../attachments/services/attachments-service.service";

export class ServicePrintPageComponent implements IController {
  service: any;
  printTaskPurpose: any;
  onServiceReady: Function;

  private logoUrl: any;
  private blobNames: string[] = [];
  private serviceTasksBlobNameMap: any = {};
  private serviceTasksBlobUrlMap: any = {};

  constructor(private splitService, private attachmentsService: AttachmentsService) {
  }

  $onInit() {
    this.logoUrl = this.splitService.getSiteLogoUrl();
    this._initServiceTasksPods();
  }

  private _initServiceTasksPods(){
    _.forEach(this.service.taskList, task => {
      this.serviceTasksBlobNameMap[task.id] = [];
      if (task.taskSpec.identifications['signatureBlobName']) {
        this.serviceTasksBlobNameMap[task.id].push(task.taskSpec.identifications['signatureBlobName']);
        this.blobNames.push(task.taskSpec.identifications['signatureBlobName']);
      }
      if (task.taskSpec.identifications['visitSummaryBlobName']) {
        this.serviceTasksBlobNameMap[task.id].push(task.taskSpec.identifications['visitSummaryBlobName']);
        this.blobNames.push(task.taskSpec.identifications['visitSummaryBlobName']);
      }
      if (task.taskSpec.identifications['photographPersonBlobName']) {
        this.serviceTasksBlobNameMap[task.id].push(task.taskSpec.identifications['photographPersonBlobName']);
        this.blobNames.push(task.taskSpec.identifications['photographPersonBlobName']);
      }
    })
    if(this.blobNames.length){
      this.attachmentsService.getAttachmentsUrls(this.blobNames)
        .then((attachmentsUrls: any[]) => {
          const mapByName = _.mapKeys(attachmentsUrls, (value, key) => {
            return value.name;
          });
          this._setTasksPodsUrls(mapByName);
        });
    } else {
      this.onServiceReady({serviceId: this.service.id});
    }
  }

  private _setTasksPodsUrls(attachmentsUrls) {
    _.forOwn(this.serviceTasksBlobNameMap, (blobNames, taskId) => {
      this.serviceTasksBlobUrlMap[taskId] = [];
      _.forEach(blobNames, blobName => {
        this.serviceTasksBlobUrlMap[taskId].push(attachmentsUrls[blobName].url);
      })
    });
    this.onServiceReady({serviceId: this.service.id});
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('servicePrintPage', {
    bindings: {
      service: '<',
      printTaskPurpose: '<?',
      onServiceReady: '&'
    },
    template: require('./service-print-page.html').default,
    controller: ServicePrintPageComponent
  });



